import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

@Injectable()
export abstract class TwoFaService<ErrorPayload> {
  public abstract sendSmsCode(phoneNumber: string): void;
  public abstract enableSmsAuth(phoneNumber: string, code: string): void;
  public abstract enableAppAuth(code: string): void;

  public abstract getSmsSendSuccessAction(): Observable<void>;
  public abstract getSmsSendFailAction(): Observable<void>;

  public abstract getEnableSmsAuthFailAction(): Observable<{
    payload: { error: ErrorPayload };
  }>;
  public abstract getEnableSmsAuthSuccessAction(): Observable<void>;

  public abstract getEnableAppAuthSuccessAction(): Observable<void>;
  public abstract getEnableAppAuthFailAction(): Observable<{
    payload: { error: ErrorPayload };
  }>;

  public abstract selectTwoFaData(): Observable<any>;
}
